import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../css/modules/Footer.module.css';

function Footer() {
  return (
    <div className={styles.footer}>
      <div className={styles.footerLinks}>
      </div>  
      <div className={styles.footerLinks}>
        <Link to="/regulamin">
          Regulamin
        </Link>
        <Link to="/polityka-prywatnosci">
          Polityka prywatności
        </Link>
        <Link to="/pytania-na-pozwolenie-na-bron-patent-strzelecki">
          Pytania
        </Link>   
        {/* Zwykły <a> do zewnętrznej aplikacji Next.js z follow/index */}
        <a href="/egzamin">
          Egzamin na patent strzelecki
        </a>
        <Link to="/kontakt">
          Kontakt
        </Link>   
      </div>
    </div>
  );
}

export default Footer;
